<script>
import Vue from 'vue';
import AutoComplete from '../AutoComplete/AutoComplete.vue';
import AutoCompleteMulti from '../AutoCompleteMulti/AutoCompleteMulti.vue';
import ContractManagementList from '../ContractManagementList/ContractManagementList.vue';
import ContractManagementEditUpload from '../ContractManagementEditUpload/ContractManagementEditUpload.vue';
import ContractManagementEditImages from '../ContractManagementEditImages/ContractManagementEditImages.vue';
import ContractManagementEditFormAdd from '../ContractManagementEditFormAdd/ContractManagementEditFormAdd.vue';
import ContractManagementEditBrands from '../ContractManagementEditBrands/ContractManagementEditBrands.vue';
import {mapState, mapActions, mapGetters} from 'vuex';

export default Vue.extend({
    components: {
        AutoComplete,
        AutoCompleteMulti,
        ContractManagementList,
        ContractManagementEditUpload,
        ContractManagementEditImages,
        ContractManagementEditFormAdd,
        ContractManagementEditBrands,
    },
    computed: {
        ...mapState({
            form: state => state.contract.contractManagement.form,
            trigger: state => state.contract.trigger,
            items: state => state.contract.contractManagement.supplier.items,
        }),
        ...mapGetters({
            getContractManagementSites: 'contract/getContractManagementSites'
        })
    },
    methods: {
        ...mapActions({
            contractManagementFormSet: 'contract/contractManagementFormSet',
            contractManagementFormUnset: 'contract/contractManagementFormUnset',
            contractManagementCopyExisting: 'contract/contractManagementCopyExisting',
            contractManagementSetNoChanges: 'contract/contractManagementSetNoChanges'
        }),
        noChanges(obj) {
            // All parts except sites and accommodations will have this feature
            if (obj.subPart !== 'siteInfo' && obj.subPart !== 'accInfo' && obj.subPart !== 'brands') {
                // Display alert before inserting 'No changes'
                if (confirm(this.$t('contractManagement.noChangesConfirm'))) {
                    this.contractManagementSetNoChanges(obj);
                }
            }
        }
    }
});
</script>
<template>
    <div class="contract-management-edit-form">
        <div class="contract-management-edit-form__content">
            <div class="contract-management-edit-form__header">
                <div class="contract-management-edit-form__heading">
                    <span>{{ $t('contractManagement.edit.form.header.heading.' + form.part) }} > </span>
                    <span class="contract-management-edit-form__sub-heading">
                        {{ $t('contractManagement.edit.form.subHeader.' + form.subPart) }}
                    </span>
                    <span v-if="form.subPart === 'notes'" class="contract-management-edit-form__optional">
                        ({{ $t('contractManagement.edit.form.optional') }})
                    </span>
                    <span v-if="form.subPart !== 'siteInfo' && form.subPart !== 'accInfo' && form.subPart !== 'brands' && form.subPart !== 'notes'"
                          class="contract-management-edit-form__btn"
                          @click="noChanges({part: form.part, subPart: form.subPart, text: $t('contractManagement.edit.progress.defaultText')})">
                        {{ $t('contractManagement.edit.form.copy') }}
                    </span>
                    <span v-if="form.subPart === 'siteInfo' || form.subPart === 'accInfo'"
                          class="contract-management-edit-form__btn"
                          @click="contractManagementCopyExisting">
                        {{ $t('contractManagement.edit.form.copy') }}
                    </span>
                </div>
            </div>
            <div class="contract-management-edit-form__body">
                <div class="contract-management-edit-form__form">
                    <div v-if="form.part === 'basic' || form.subPart === 'arrivalDeparture'"
                         class="contract-management-edit-form__form-input">
                        <textarea :placeholder="$t('contractManagement.edit.form.placeholder.' + form.subPart)"
                                  :value="form[form.part][form.subPart].text"
                                  class="contract-management-edit-form__input contract-management-edit-form__input-text"
                                  rows="15"
                                  @input="contractManagementFormSet({part: form.part, subPart: form.subPart, text: $event.target.value})"/>
                    </div>
                    <div v-if="form.part === 'extended' && form.subPart !== 'arrivalDeparture' && form.subPart !== 'brands'"
                         class="contract-management-edit-form__form-input">
                        <div class="contract-management-edit-form__add-field-mobile">
                            <contract-management-edit-form-add/>
                        </div>
                        <div v-if="form.subPart === 'accInfo'" class="contract-management-edit-form__sites">
                            <auto-complete-multi :placeholder="$t('contractManagement.edit.form.autoComplete.multi')"
                                                 :values="form[form.part][form.subPart][form.index].sites"
                                                 :items="getContractManagementSites"
                                                 :value-attribute="'name'"
                                                 @add="contractManagementFormSet({part: form.part, subPart: form.subPart, index: form.index, site: $event})"
                                                 @remove="contractManagementFormUnset({part: form.part, subPart: form.subPart, index: form.index, site: $event})"/>
                        </div>
                        <div v-if="form.subPart === 'siteInfo'" class="contract-management-edit-form__checkboxes">

                            <span class="contract-management-edit-form__checkbox-label">
                                {{ $t('contractManagement.edit.form.checkbox') }}:
                            </span>
                            <div :class="['contract-management-edit-form__checkbox', {'contract-management-edit-form__checkbox--checked': form[form.part][form.subPart][form.index].showInContract}]"
                                 @click="contractManagementFormSet({part: form.part, subPart: form.subPart, index: form.index, show: !form[form.part][form.subPart][form.index].showInContract})"
                            />
                        </div>
                        <div class="contract-management-edit-form__add-field">
                            <contract-management-edit-form-add/>
                        </div>
                        <auto-complete :input="form[form.part][form.subPart][form.index]"
                                       :placeholder="$t('contractManagement.edit.form.autoComplete.' + form.subPart)"
                                       :values="form[form.part][form.subPart]"
                                       :items="items[form.subPart]"
                                       class="contract-management-edit-form__input contract-management-edit-form__input-title"
                                       @change="contractManagementFormSet({part: form.part, subPart: form.subPart, index: form.index, item: $event})"
                        />
                        <textarea :placeholder="$t('contractManagement.edit.form.placeholder.' + form.subPart + '.text')"
                                  :value="form[form.part][form.subPart][form.index].text"
                                  class="contract-management-edit-form__input contract-management-edit-form__input-text-small"
                                  rows="15"
                                  @input="contractManagementFormSet({part: form.part, subPart: form.subPart, index: form.index, text: $event.target.value})"/>
                        <contract-management-edit-images/>
                    </div>
                    <div v-if="form.subPart === 'brands'">
                        <contract-management-edit-brands/>
                    </div>
                </div>
            </div>
            <div v-if="form.subPart !== 'brands'">
                <div class="contract-management-edit-form__upload">
                    <contract-management-edit-upload/>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractManagementEditForm/ContractManagementEditForm.vue